import { PropertiesType } from 'V2/Types';
import { getAnalytics } from 'V2/Services/GetAnalytics';
import { postAnalyticsEvent } from 'V2/Services/PostAnalyticsEvent';
import { EventName } from 'V2/Services/PostAnalyticsEvent/PostAnalyticsEvent'; // This can't be folded into the import above as I'm seeing the same error outlined here - https://stackoverflow.com/a/51158269
import { Datadog, DataLayer, setAnalytics } from 'V2/Analytics';
import { LogToService } from 'V2/Utilities/Logger';

type InitApplicationType = () => Promise<PropertiesType>;

export const initApplication: InitApplicationType = () =>
  new Promise((resolve, reject) => {
    const appId = sessionStorage.getItem('appId');
    const clickId = sessionStorage.getItem('clickId');

    Datadog.addUserContext({
      appId,
      clickId,
    });

    getAnalytics()
      .then((response) => {
        const {
          flow_name,
          campaign_name,
          partner_slug_url: slug,
          partner_name,
          insurance_application_id,
          attribution_type,
        } = response.data;

        if (insurance_application_id) {
          postAnalyticsEvent(insurance_application_id.toString(), {
            event_name: EventName.FLOW_START,
            context_data: {},
          }).catch((error) => {
            LogToService.captureException({
              errorType: 'client',
              message: `Failed to post analytics event for insurance_application_started: ${error.message}`,
              thread: 'InitApplication',
              error: error instanceof Error ? error : new Error(error),
            });
          });
        }

        DataLayer.push({
          event: 'attribution_data',
          flow_name: flow_name,
          campaign_name: campaign_name || '',
          slug,
          partner_name,
          insurance_application_id,
          partner_channel:
            typeof attribution_type === 'string' && attribution_type
              ? attribution_type.split('_')[0]
              : '',
        });

        setAnalytics(response.data);
        resolve(response.data);
      })
      .catch(reject);
  });
